<!-- Modal Upload-->
<div class="form-modal" *ngIf="form">
  <h1 mat-dialog-title>{{ 'ADD_FILE' | translate}}</h1>
  <div mat-dialog-content [formGroup]="form">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="form.controls.FilesInfo.controls.length === 0">
      <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="hasBaseDropZoneOver=$event"
        [uploader]="uploader" class="well my-drop-zone no-margin" (click)="inputFile.click()">
        {{ 'DROP_AREA_DOCUMENTS' | translate }}
      </div>
      <input type="file" ng2FileSelect [uploader]="uploader" #inputFile class="hide" (change)="addFile($event)"
        multiple />
      <span *ngIf="formErrors.FilesInfo" class="field-validation-valid text-danger"
        [translate]>{{formErrors.FilesInfo}}</span>
    </div>
    <!-- Ficheiros -->
    <div formArrayName="FilesInfo">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
        *ngFor="let fileInfo of form.controls.FilesInfo.controls; let i=index" [formGroupName]="i">
        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-12 no-padding">
          <mat-form-field class='allwidth' [ngClass]="{ 'mat-input-invalid': formErrors.FilesInfo.OriginalFileName }">
            <mat-label>{{ 'FILE' | translate}}</mat-label>
            <input matInput formControlName="OriginalFileName">
          </mat-form-field>
          <span *ngIf="formErrors.FilesInfo.OriginalFileName" class="field-validation-valid text-danger"
            [translate]>{{formErrors.FilesInfo.OriginalFileName}}</span>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding">
          <button type="button" (click)="removeFile(i)" class="btn btn-white pull-right"
            style="margin-top: 12px;padding: 2px 4px 2px 4px;">
            <span title="{{'BUTTON.DELETE' | translate}}"><i class="far fa-trash-alt red backwhite"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 spacer-bottom-xs"></div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="dialogRef.close(false)">
        <span title="{{'BUTTON.CANCEL' | translate}}">
          {{'BUTTON.CANCEL'|translate}}
        </span>
      </button>

      <button type="button" class="btn btn-primary" (click)="save()">
        <span title="{{'BUTTON.SAVE' | translate}}">
          {{'BUTTON.SAVE'|translate}}
        </span>
      </button>
    </div>
  </div>
</div>